import http from "../../helpers/http";

import {
    FETCH_BLOG_CONTENT,
    FETCH_BLOG_CONTENT_SUCCESS,
    FETCH_BLOG_CONTENT_FAILED
} from "./actionTypes";

export const fetchBlog = () => (dispatch) => {
    dispatch({
        type: FETCH_BLOG_CONTENT,
        payload: null
    });
    http
        .get("blog-page")
        .then(({ data }) => {
            dispatch({
                type: FETCH_BLOG_CONTENT_SUCCESS,
                payload: data
            });
        })
        .catch((error) => {
            dispatch({
                type: FETCH_BLOG_CONTENT_FAILED,
                payload: error
            });
        });
};
